import styled from "styled-components";
import { space, SpaceProps } from "styled-system";

export const SidebarGroup = styled.div<SpaceProps>`
  padding-bottom: 1.25rem;
  margin-bottom: 1.25rem;
  border-bottom: dotted 2px ${(props) => props.theme.colors?.outline};
  ${space}
`;
